<template>
    <div class="title-container">
        <h2 class="title">{{ text }}</h2>    
        <hr />
    </div>
</template>
<script>
    export default {
        props: {
            text: {
                type: String,
                required: true
            }
        }
    }
</script>
<style scoped>
    .title {
        color: #2D2461;
    }
</style>